const buildOptions = (data, contentType = 'application/json') => {
    const options = {};

    if (data) {
        if (contentType === 'multipart/form-data') {

            //let formData = new FormData();
            //formData.append('PdfFile', data);

            options.body = data;
        } else {
            options.body = JSON.stringify(data);
            options.headers = {
                'Content-Type': 'application/json'
            };
        }
    }
    const token = JSON.parse(sessionStorage.getItem('auth')) ? JSON.parse(sessionStorage.getItem('auth')).token : null;
    const sessionToken = sessionStorage.getItem('sessionToken') ? sessionStorage.getItem('sessionToken') : null;
    const tempToken = sessionStorage.getItem('tempToken') ? sessionStorage.getItem('tempToken') : null;


    if (token || tempToken) {
        if (token) {
            options.headers = {
                ...options.headers,
                'Authorization': `Bearer ${token}`
            };
        } else if (tempToken) {
            options.headers = {
                ...options.headers,
                'Authorization': `Bearer ${tempToken}`
            };
        }
    }

    if (sessionToken) {
        options.headers = {
            ...options.headers,
            'SessionToken': sessionToken
        };
    }

    return options;
};

const request = async (method, url, data, contentType) => {

   
    const response = await fetch(url, {
        method,
        ...buildOptions(data, contentType),
    });

    
   
    if (response.status === 204) {
        return {};
    }

    const result = await response.json();

    if (response.status == 400 && result.title) {
            throw new Error('Опитай пак!');
    }

    const oldSessionToken = sessionStorage.getItem('sessionToken');
    const newSessionToken = response.headers.get('SessionToken');

    if (oldSessionToken != newSessionToken && newSessionToken != null) {
        sessionStorage.setItem('sessionToken', newSessionToken);
    }

    if (response.headers.get('Api-Supported-Versions') != sessionStorage.getItem('apiVersion') && !localStorage.getItem('apiVersion')) {
        window.location.reload();
        return;
    } else if (!sessionStorage.getItem('apiVersion')) {
        const apiVersion = response.headers.get('Api-Supported-Versions');
        sessionStorage.setItem('apiVersion', apiVersion);
    }


    if (!response.ok) {
        throw result;
    }

    return result;
};

const requestPdf = async (method, url, data) => {

    const response = await fetch(url, {
        method,
        ...buildOptions(data),
    });

    if (response.status === 204) {
        return {};
    }

    if (response.status === 400) {
        throw new Error('Няма активно класиране!');
    }


    if (response.headers.get('Api-Supported-Versions') != sessionStorage.getItem('apiVersion')) {
        window.location.reload();
        return;
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    if (!response.ok) {
        const result = await response.json();
        throw result;
    }

    return downloadUrl;
};

export const get = request.bind(null, 'GET');
export const post = request.bind(null, 'POST');
export const put = request.bind(null, 'PUT');
export const remove = request.bind(null, 'DELETE');
export const patch = request.bind(null, 'PATCH');
export const postFile = request.bind(null, 'POST');
export const getPdf = requestPdf.bind(null, 'POST');
export const getGetPdf = requestPdf.bind(null, 'GET');
export const putPdf = requestPdf.bind(null, 'PUT');
export const getArchivePdfRef = requestPdf.bind(null, 'GET');

